export default __webpack_public_path__ + "static/media/markit-shop-mobile.b1695aaa.png";